"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCurrentWidth = require("./useCurrentWidth");
Object.keys(_useCurrentWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCurrentWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCurrentWidth[key];
    }
  });
});
var _useScrollPosition = require("./useScrollPosition");
Object.keys(_useScrollPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useScrollPosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useScrollPosition[key];
    }
  });
});
var _useCurrentHeight = require("./useCurrentHeight");
Object.keys(_useCurrentHeight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCurrentHeight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCurrentHeight[key];
    }
  });
});
var _useIntersectionObserver = require("./useIntersectionObserver");
Object.keys(_useIntersectionObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useIntersectionObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useIntersectionObserver[key];
    }
  });
});
var _useFocus = require("./useFocus");
Object.keys(_useFocus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFocus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useFocus[key];
    }
  });
});
var _useHideKnockList = require("./useHideKnockList");
Object.keys(_useHideKnockList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHideKnockList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useHideKnockList[key];
    }
  });
});
var _useKnockDisplayName = require("./useKnockDisplayName");
Object.keys(_useKnockDisplayName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useKnockDisplayName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useKnockDisplayName[key];
    }
  });
});
var _useVideoThumbnail = require("./useVideoThumbnail");
Object.keys(_useVideoThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoThumbnail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoThumbnail[key];
    }
  });
});
var _useWindowEvent = require("./useWindowEvent");
Object.keys(_useWindowEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useWindowEvent[key];
    }
  });
});
var _useStudioLiteContext = require("./useStudioLiteContext");
Object.keys(_useStudioLiteContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useStudioLiteContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useStudioLiteContext[key];
    }
  });
});
var _usePresenterStandaloneContext = require("./usePresenterStandaloneContext");
Object.keys(_usePresenterStandaloneContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresenterStandaloneContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresenterStandaloneContext[key];
    }
  });
});
var _useQuery = require("./useQuery");
Object.keys(_useQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useQuery[key];
    }
  });
});
var _useBroadcastTimeRange = require("./useBroadcastTimeRange");
Object.keys(_useBroadcastTimeRange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBroadcastTimeRange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBroadcastTimeRange[key];
    }
  });
});
var _useCountDownTimer = require("./useCountDownTimer");
Object.keys(_useCountDownTimer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCountDownTimer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCountDownTimer[key];
    }
  });
});
var _usePresentationControl = require("./usePresentationControl");
Object.keys(_usePresentationControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresentationControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresentationControl[key];
    }
  });
});
var _useElementInViewport = require("./useElementInViewport");
Object.keys(_useElementInViewport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useElementInViewport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useElementInViewport[key];
    }
  });
});
var _useUvsTimedOut = require("./useUvsTimedOut");
Object.keys(_useUvsTimedOut).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useUvsTimedOut[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUvsTimedOut[key];
    }
  });
});
var _useKnockRequest = require("./useKnockRequest");
Object.keys(_useKnockRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useKnockRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useKnockRequest[key];
    }
  });
});
var _useVideoElementDatadogMetrics = require("./useVideoElementDatadogMetrics");
Object.keys(_useVideoElementDatadogMetrics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoElementDatadogMetrics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoElementDatadogMetrics[key];
    }
  });
});
var _useLaunchDarkly = require("./useLaunchDarkly");
Object.keys(_useLaunchDarkly).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLaunchDarkly[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useLaunchDarkly[key];
    }
  });
});
var _useGetUserMedia = require("./useGetUserMedia");
Object.keys(_useGetUserMedia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetUserMedia[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetUserMedia[key];
    }
  });
});
var _useResizedObserver = require("./useResizedObserver");
Object.keys(_useResizedObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useResizedObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useResizedObserver[key];
    }
  });
});
var _useModal = require("./useModal");
Object.keys(_useModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useModal[key];
    }
  });
});
var _useNotification = require("./useNotification");
Object.keys(_useNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useNotification[key];
    }
  });
});
var _useJoinComponentStates = require("./useJoinComponentStates/useJoinComponentStates");
Object.keys(_useJoinComponentStates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useJoinComponentStates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useJoinComponentStates[key];
    }
  });
});
var _useInitializeBackgroundFilter = require("./useInitializeBackgroundFilter/useInitializeBackgroundFilter");
Object.keys(_useInitializeBackgroundFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useInitializeBackgroundFilter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useInitializeBackgroundFilter[key];
    }
  });
});
var _useGetMediaDevices = require("./useGetMediaDevices/useGetMediaDevices");
Object.keys(_useGetMediaDevices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetMediaDevices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetMediaDevices[key];
    }
  });
});
var _useWindowDimensions = require("./useWindowDimensions/useWindowDimensions");
Object.keys(_useWindowDimensions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowDimensions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useWindowDimensions[key];
    }
  });
});